import { AppRoutePaths } from '@/routing/route_paths'
import { FormEditState } from '@/storage/applications/applicationStatusSlice'
import { SectionStartAndEnd } from './family-application.routing.types'

const identity_verification_start_page =
  AppRoutePaths.family_application.identity_verification.index
const income_verification_start_page =
  AppRoutePaths.family_application.income_verification.index
const attestations_start_page =
  AppRoutePaths.family_application.attestations.index
const residency_verification_start_page =
  AppRoutePaths.family_application.residency_verification.index
const student_details_start_page =
  AppRoutePaths.family_application.student_details.index

const identity_verification_flow: SectionStartAndEnd = {
  start: identity_verification_start_page,
  end: [residency_verification_start_page],
}

const student_details_verification_flow: SectionStartAndEnd = {
  start: student_details_start_page,
  end: [],
}

const income_verification_flow: SectionStartAndEnd = {
  start: income_verification_start_page,
  end: [],
}

const EDIT_PATHS_PER_FLAG: Record<FormEditState, SectionStartAndEnd> = {
  // WHEN USER CLICKS "EDIT X" ON THE SUMMARY PAGE
  'form-edit-identity-verification': {
    start: identity_verification_start_page,
    end: [],
  },

  // IDENTITY FLAGS
  identity: {
    start: identity_verification_start_page,
    end: [],
  },

  none: {
    start: AppRoutePaths.family_application.index,
    end: [],
  },
  residency: {
    start: residency_verification_start_page,
    end: [],
  },


  // IDENTITY FLAGS
  clearme_data_inaccurate: identity_verification_flow,

  // STUDENT FLAGS
  'dashboard-edit-student-details': student_details_verification_flow,
  'form-edit-student-details': student_details_verification_flow,
  student_age: student_details_verification_flow,
  relation_to_student: student_details_verification_flow,
  enrolled_in_lea: {
    start: AppRoutePaths.family_application.student_details.lea,
    end: [
      AppRoutePaths.family_application.student_details.capture_instructions,
    ],
  },
  student_age_sep: student_details_verification_flow,
  student_age_affidavit: student_details_verification_flow,
  student_age_special_education: student_details_verification_flow,
  received_another_scholarship: {
    start: AppRoutePaths.family_application.student_details.scholarships,
    end: [AppRoutePaths.family_application.student_details.lea],
  },

  // INCOME FLAGS
  'form-edit-income-details': {
    start: income_verification_start_page,
    end: [attestations_start_page],
  },
  tax_commission_applicant_attested_incorrect_data: income_verification_flow,
  tax_commission_skipped_by_applicant: income_verification_flow,
  tax_commission_returned_data_does_not_match: income_verification_flow,
  tax_commission_error: income_verification_flow,
  review_income_documents: income_verification_flow
}

export { EDIT_PATHS_PER_FLAG }
